<template>
  <div class="new-casino-card-section" v-if="!hideToplistLabel">
    <div class="container">
      <h2 v-if="componentTitle && componentTitle != ''">
        {{ componentTitle }}
      </h2>
      <div class="mobile-scroller disable">
        <div class="row">
          <div
            class="col-lg-3"
            v-for="(card, index) in componentData"
            :key="index"
          >
            <div class="new-casino-card">
              <div class="new-casino-card-content">
                <div
                  class="triangle"
                  v-if="Object.keys(hasTag(card.tags)).length > 0"
                  :style="{
                    backgroundColor:
                      Object.keys(hasTag(card.tags)).length > 0
                        ? hasTag(card.tags).color
                        : null,
                  }"
                >
                  <i
                    ><img
                      :src="hasTag(card.tags).icon"
                      width="14"
                      height="14"
                      alt="tag-icons"
                  /></i>
                </div>
                <div class="bg-holder">
                  <img
                    :src="
                      card.product_assets.filter(
                        (ele) =>
                          ele.asset_category_name ===
                          assetsSize.pro_asset_sizes.background
                      ).length > 0
                        ? card.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.background
                            )
                            .shift().url
                        : card.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              'product_logo_background'
                          ).length > 0
                        ? card.product_assets
                            .filter(
                              (ele) =>
                                ele.asset_category_name ===
                                'product_logo_background'
                            )
                            .shift().url
                        : $root.site_url + $root.asset_path + '/failure.png'
                    "
                    :alt="
                      getAltText(
                        card.product_name,
                        card.product_assets.filter(
                          (ele) =>
                            ele.asset_category_name ===
                            assetsSize.pro_asset_sizes.background
                        ).length > 0
                          ? card.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  assetsSize.pro_asset_sizes.background
                              )
                              .shift().url
                          : card.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                'product_logo_background'
                            ).length > 0
                          ? card.product_assets
                              .filter(
                                (ele) =>
                                  ele.asset_category_name ===
                                  'product_logo_background'
                              )
                              .shift().url
                          : $root.site_url + $root.asset_path + '/failure.png'
                      )
                    "
                  />
                </div>
                <div class="cas-panel">
                  <template v-if="checkImageAsset(card.product_assets)">
                    <a
                      :title="card.product_name"
                      :href="getGoLink(card.go_link, card.slug)"
                      class="partner-logo sim-logo cas-link cas-logo"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <img
                        v-if="
                          $root.enable_lazyload &&
                          assetsSize &&
                          assetsSize.pro_asset_sizes
                        "
                        v-lazy="
                          card.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assetsSize.pro_asset_sizes.medium
                          ).length > 0
                            ? card.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assetsSize.pro_asset_sizes.medium
                                )
                                .shift().url
                            : ''
                        "
                        height="50"
                        width="50"
                        class="sm-img"
                        :alt="
                          getAltText(
                            card.product_name,
                            card.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.medium
                            ).length > 0
                              ? card.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assetsSize.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : ''
                          )
                        "
                      />
                      <img
                        v-else-if="assetsSize && assetsSize.pro_asset_sizes"
                        :src="
                          card.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              assetsSize.pro_asset_sizes.medium
                          ).length > 0
                            ? card.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    assetsSize.pro_asset_sizes.medium
                                )
                                .shift().url
                            : $root.site_url + $root.asset_path + '/failure.png'
                        "
                        height="50"
                        width="50"
                        class="sm-img"
                        :alt="
                          getAltText(
                            card.product_name,
                            card.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                assetsSize.pro_asset_sizes.medium
                            ).length > 0
                              ? card.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      assetsSize.pro_asset_sizes.medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                          )
                        "
                      />
                      <div class="partner-hover wd-sim">
                        <div
                          class="partner-hover-inner"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="16"
                            viewBox="0 0 10 16"
                            fill="none"
                          >
                            <path
                              d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </template>
                  <a
                    :title="card.product_name"
                    :href="getGoLink(card.go_link, card.slug)"
                    class="cas-title cas-link text-hover"
                    target="_blank"
                    :rel="
                      $root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'
                    "
                    >{{ card.product_name }}
                  </a>
                  <StarRating
                    :rating="parseFloat((card.rating / 2).toFixed(1))"
                    :classParam="'star-cls'"
                  />
                </div>
                <span class="bonus-text similar-card-bonus text-hover">
                  <template v-if="hideBonusLabel">
                    <span>{{ $root.i18n.hidden_partner_bonus }}</span>
                  </template>
                  <template v-else>
                    <a
                      :title="card.product_name"
                      :href="getGoLink(card.go_link, card.slug)"
                      class="cas-link"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      v-if="
                        card.bonus_match &&
                        card.exclusive_bonus_amount &&
                        card.exclusive_bonus_match
                      "
                      >{{ card.exclusive_bonus_match }}%
                      {{ $root.i18n.match_bonus_up_to }}
                      {{
                        card.exclusive_bonus_amount
                          | currency(card.bonus_currency)
                      }}</a
                    >
                    <a
                      :title="card.product_name"
                      :href="getGoLink(card.go_link, card.slug)"
                      class="cas-link"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      v-if="
                        card.bonus_match &&
                        !card.exclusive_bonus_amount &&
                        card.bonus_amount
                      "
                      >{{ card.bonus_match }}% {{ $root.i18n.up_to }}
                      {{ card.bonus_amount | currency(card.bonus_currency) }}</a
                    >
                    <a
                      :title="card.product_name"
                      :href="getGoLink(card.go_link, card.slug)"
                      class="cas-link"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                      v-if="card.freespin || card.freebie_name"
                    >
                      <template
                        v-if="
                          (card.exclusive_bonus_amount || card.bonus_amount) &&
                          card.bonus_match
                        "
                        >+</template
                      >
                      <template v-if="card.freespin">
                        <template v-if="card.show_freebie_currency === '1'">{{
                          card.freespin | currency(card.bonus_currency)
                        }}</template>
                        <template v-else>{{ card.freespin }}</template>
                        {{ card.freebie_name }}
                      </template>
                      <template v-else>{{ card.freebie_name }}</template>
                    </a>
                  </template>
                </span>
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="card.product_name"
                    class="review-link rev-text"
                    v-if="card.review_link"
                    :href="getRouteLink(card.review_link, 'review')"
                    >{{
                      getPartnerGlobalString(
                        $root.i18n.read_our_review,
                        card.product_name
                      )
                    }}</a
                  >
                  <span class="emt-sp rev-text" v-else>&nbsp;</span>
                </template>
                <template v-else>
                  <router-link
                    :title="card.product_name"
                    class="review-link rev-text"
                    v-if="card.review_link"
                    :to="getRouteLink(card.review_link, 'review')"
                    >{{
                      getPartnerGlobalString(
                        $root.i18n.read_our_review,
                        card.product_name
                      )
                    }}</router-link
                  >

                  <span class="emt-sp rev-text" v-else>&nbsp;</span>
                </template>
                <a
                  :title="card.product_name"
                  :href="getGoLink(card.go_link, card.slug)"
                  :class="{
                    'cta cta-primary cta-block cta-promotion btn-gray custom-btn cus-sim-btn hover-btn cas-link': true,
                    'text-white':
                      !$root.override_ctabtntxt_color &&
                      !getContrastYIQ($root.color_schema.primary_btn),
                    'text-gray':
                      !$root.override_ctabtntxt_color &&
                      getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                  ><span class="cta-text">{{ card.cta_button_text }}</span
                  ><span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `simpp`"
                    >{{ char }}</span
                  >
                </a>
                <ul
                  class="payment-options pos-relative pay-img"
                  v-if="
                    card.supported_payments.length > 0 &&
                    card.supported_payments_total > 0
                  "
                >
                  <li
                    v-for="(data, index) in card.supported_payments.slice(0, 3)"
                    :key="index + 'k'"
                  >
                    <figure class="popup-btn-content">
                      <img
                        v-if="$root.enable_lazyload"
                        v-lazy="data.url"
                        :alt="getAltText(data.name, data.url)"
                        width="50"
                        height="50"
                      />
                      <img
                        v-else
                        :src="data.url"
                        :alt="getAltText(data.name, data.url)"
                        width="50"
                        height="50"
                      />
                    </figure>
                  </li>

                  <!-- No + If List Length is exactly 4 -->
                  <template v-if="card.supported_payments_total === 4">
                    <li
                      v-for="(data, index) in card.supported_payments.slice(3)"
                      :key="index"
                    >
                      <figure>
                        <img
                          v-if="$root.enable_lazyload"
                          v-lazy="data.url"
                          :alt="getAltText(data.name, data.url)"
                          width="50"
                          height="50"
                        />
                        <img
                          v-else
                          :src="data.url"
                          :alt="getAltText(data.name, data.url)"
                          width="50"
                          height="50"
                        />
                      </figure>
                    </li>
                  </template>
                  <!-- No + If List Length is exactly 4 END -->
                  <!-- Small Screen + btn for redirection -->
                  <li
                    class="show-btn-sm"
                    v-if="card.supported_payments_total > 4"
                  >
                    <figure>
                      <template v-if="$root.enable_piwik_reload">
                        <a
                          :title="card.product_name"
                          :href="getRouteLink(card.review_link, 'review')"
                          class="more-pay"
                        >
                          <i>
                            <img
                              width="13"
                              height="13"
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/svg-icons/plus.svg'
                              "
                              alt="Plus Icon"
                            />
                          </i>
                          {{
                            card.supported_payments_total -
                            (card.supported_payments.length > 3
                              ? 3
                              : card.supported_payments.length)
                          }}
                        </a>
                      </template>
                      <template v-else>
                        <router-link
                          :title="card.product_name"
                          :to="getRouteLink(card.review_link, 'review')"
                          class="more-pay"
                        >
                          <i>
                            <img
                              width="13"
                              height="13"
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/svg-icons/plus.svg'
                              "
                              alt="Plus Icon"
                            />
                          </i>
                          {{
                            card.supported_payments_total -
                            (card.supported_payments.length > 3
                              ? 3
                              : card.supported_payments.length)
                          }}
                        </router-link>
                      </template>
                    </figure>
                  </li>
                  <!-- Small Screen + btn for redirection END -->
                  <!-- Modal Show Hide Button -->
                  <template
                    v-if="componentAttrs && componentAttrs.enable_payment_popup"
                  >
                    <li
                      @click="showHideModal(modalIdArr[index])"
                      :class="{
                        'show-btn-md': true,
                        'd-none': modalOnDisplay == modalIdArr[index],
                      }"
                      :id="`show-btn-${modalIdArr[index]}`"
                      v-if="card.supported_payments_total > 4"
                    >
                      <figure class="popup-btn-content">
                        <span class="plus">
                          <i>
                            <img
                              width="13"
                              height="13"
                              class="plus"
                              :src="
                                $root.site_url +
                                $root.asset_path +
                                '/svg-icons/plus.svg'
                              "
                              alt="Plus Icon"
                            />
                          </i>
                          {{
                            card.supported_payments_total -
                            (card.supported_payments.length > 3
                              ? 3
                              : card.supported_payments.length)
                          }}
                        </span>
                      </figure>
                    </li>
                    <li
                      @click="showHideModal(null)"
                      class="hide-btn"
                      v-if="modalOnDisplay == modalIdArr[index]"
                    >
                      <figure class="popup-btn-content">
                        <span class="minus"></span>
                      </figure>
                    </li>
                    <!-- Modal Show Hide Button End -->
                    <!-- Modal Implementation -->
                    <template v-if="card.supported_payments_total > 4">
                      <div
                        class="modal-wrapper"
                        :id="`modal-content-${modalIdArr[index]}`"
                        v-if="modalOnDisplay == modalIdArr[index]"
                      >
                        <ul class="modal-list">
                          <li
                            v-for="(
                              data, index
                            ) in card.supported_payments.slice(3)"
                            :key="index"
                          >
                            <figure>
                              <img
                                class="modal-img"
                                v-if="$root.enable_lazyload"
                                v-lazy="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                              <img
                                class="modal-img"
                                v-else
                                :src="data.url"
                                :alt="getAltText(data.name, data.url)"
                              />
                            </figure>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <li
                      class="show-btn-md"
                      v-if="card.supported_payments_total > 4"
                    >
                      <figure>
                        <template v-if="$root.enable_piwik_reload">
                          <a
                            :title="card.product_name"
                            :href="getRouteLink(card.review_link, 'review')"
                            class="more-pay"
                          >
                            <i>
                              <img
                                width="13"
                                height="13"
                                :src="
                                  $root.site_url +
                                  $root.asset_path +
                                  '/svg-icons/plus.svg'
                                "
                                alt="Plus Icon"
                              />
                            </i>
                            {{
                              card.supported_payments_total -
                              (card.supported_payments.length > 3
                                ? 3
                                : card.supported_payments.length)
                            }}
                          </a>
                        </template>
                        <template v-else>
                          <router-link
                            :title="card.product_name"
                            :to="getRouteLink(card.review_link, 'review')"
                            class="more-pay"
                          >
                            <i>
                              <img
                                width="13"
                                height="13"
                                :src="
                                  $root.site_url +
                                  $root.asset_path +
                                  '/svg-icons/plus.svg'
                                "
                                alt="Plus Icon"
                              />
                            </i>
                            {{
                              card.supported_payments_total -
                              (card.supported_payments.length > 3
                                ? 3
                                : card.supported_payments.length)
                            }}
                          </router-link>
                        </template>
                      </figure>
                    </li>
                  </template>
                  <!-- Modal Implementation End -->
                </ul>
                <div v-else class="payment-options pos-relative pay-img">
                  &nbsp;
                </div>
              </div>
              <div
                class="terms-condition-similar terms-sim"
                v-if="
                  (card.bonus_tc && card.bonus_tc != '') ||
                  (card.terms && card.terms != '')
                "
              >
                <span
                  class="cas-term"
                  v-if="card.bonus_tc && card.bonus_tc != ''"
                  v-html="card.bonus_tc.trim()"
                  :style="{ '--primary-btn': $root.color_schema.primary_btn }"
                ></span>
                <span
                  class="card-stroke"
                  v-if="
                    card.bonus_tc &&
                    card.terms &&
                    card.bonus_tc != '' &&
                    card.terms != ''
                  "
                  >|</span
                >
                <a
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  class="cas-term"
                  v-if="card.terms && card.terms != ''"
                  :href="getGoLink(card.term_link, card.slug)"
                  target="_blank"
                  >{{ card.terms }}</a
                >
              </div>
              <div class="terms-condition-similar terms-sim" v-else>&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container text-center pt-10" v-else>
    {{ $root.i18n.no_toplist_available_intime }}
  </div>
</template>

<script>
import { pSBC, getContrastYIQ } from "@/misc/misc-function";
import currency from "@/misc/currency";
import StarRating from "@/components/ui/StarRating";

export default {
  name: "SimilarCasino",
  props: [
    "componentData",
    "componentTitle",
    "componentDescription",
    "assetsSize",
    "componentAttrs",
    "pageTemplate",
  ],
  data: function () {
    return {
      modalOnDisplay: null,
      modalIdArr: [],
      hideBonusLabel: false,
      hideToplistLabel: false,
    };
  },
  components: {
    StarRating,
  },
  filters: {
    currency,
  },
  methods: {
    pSBC,
    getContrastYIQ,
    showHideModal(id) {
      this.modalOnDisplay = id;
    },
    getBonusShowHide: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabel = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabel = true;
      }
    },
  },
  mounted: function () {
    if (this.componentData && this.componentData.length > 0)
      this.getBonusShowHide(this.componentData[0]);
    this.componentData.forEach((ele) => {
      this.modalIdArr.push(Math.floor(Math.random() * (1000 - 1 + 1)) + 1);
    });

    var that = this;
    document.body.addEventListener("click", function (event) {
      var modal = document.getElementById(
        `modal-content-${that.modalOnDisplay}`
      );
      var showBtn = document.getElementById(`show-btn-${that.modalOnDisplay}`);
      if (
        modal &&
        event.target != modal &&
        !modal.contains(event.target) &&
        event.target != showBtn &&
        !showBtn.contains(event.target)
      ) {
        that.showHideModal(null);
      }
    });

    var maxHeight = 0;
    document.querySelectorAll(".similar-card-bonus").forEach((ele) => {
      if (maxHeight <= ele.offsetHeight) {
        maxHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".similar-card-bonus").forEach((ele) => {
      ele.style.height = `${maxHeight}px`;
    });

    var maxNameHeight = 0;
    document.querySelectorAll(".cas-nam").forEach((ele) => {
      if (maxNameHeight <= ele.offsetHeight) {
        maxNameHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".cas-nam").forEach((ele) => {
      ele.style.height = `${maxNameHeight}px`;
    });

    var maxRevHeight = 0;
    document.querySelectorAll(".rev-text").forEach((ele) => {
      if (maxRevHeight <= ele.offsetHeight) {
        maxRevHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".rev-text").forEach((ele) => {
      ele.style.height = `${maxRevHeight}px`;
    });

    var maxBtnHeight = 0;
    document.querySelectorAll(".cus-sim-btn").forEach((ele) => {
      if (maxBtnHeight <= ele.offsetHeight) {
        maxBtnHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".cus-sim-btn").forEach((ele) => {
      ele.style.height = `${maxBtnHeight}px`;
    });

    var maxTermHeight = 0;
    document.querySelectorAll(".terms-sim").forEach((ele) => {
      if (maxTermHeight <= ele.offsetHeight) {
        maxTermHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".terms-sim").forEach((ele) => {
      ele.style.height = `${maxTermHeight}px`;
    });

    var maxPayImgHeight = 0;
    document.querySelectorAll(".pay-img").forEach((ele) => {
      if (maxPayImgHeight <= ele.offsetHeight) {
        maxPayImgHeight = ele.offsetHeight;
      }
    });

    document.querySelectorAll(".pay-img").forEach((ele) => {
      ele.style.height = `${maxPayImgHeight}px`;
    });
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.modal-wrapper {
  display: none;
  max-width: 280px;
  background: @white;
  position: absolute;
  top: 43px;
  right: 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  max-width: 220px;
  max-height: max-content;
  z-index: 100;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.pos-relative {
  position: relative;
}

.mr-0 {
  margin-right: 0 !important;
}

.terms_tc {
  color: @lightdark;
}

.ct {
  &-similar-casino-cards {
    padding-bottom: 30px;
    .container {
      padding-right: 20px;
      z-index: 8;
      @media (min-width: @sizes[tablet]) {
        padding: 0 15px;
      }
    }
    .mobile-scroller {
      &::-webkit-scrollbar-track {
        background-color: @white;
      }
      .row [class^="col-"] {
        padding: 0 8px;
        @media (min-width: @sizes[large]) {
          padding: 0 4px;
        }
        @media (min-width: @sizes[md-large]) {
          padding: 0 8px;
        }
        &:last-child {
          padding-right: 22px;
          @media (min-width: @sizes[small]) {
            padding-right: 8px;
          }
        }
      }
      .casino-card-similar {
        padding: 15px;
        white-space: normal;
        min-width: 254px;
        max-width: 300px;
        @media (min-width: @sizes[large]) {
          padding: 10px;
          min-width: auto;
        }
        @media (min-width: @sizes[md-large]) {
          padding: 15px;
        }
      }
    }
  }
  &-review-toplist-page {
    padding-top: 30px;
  }
}

.preview {
  margin: 0px;
}

.casino-card-similar {
  h2 {
    height: 48px;
    @media (min-width: @sizes[large]) {
      height: 56px;
    }
  }
}

.text-center {
  text-align: center !important;
}
.cursor-default {
  cursor: default !important;
}

.minus {
  &:before {
    content: "-";
    font-size: 1.9rem;
  }
}

.payment-list {
  justify-content: space-between !important;
  flex-wrap: wrap !important;
  li {
    margin-right: 0px !important;
  }
}

.modal-list {
  display: flex;
  justify-content: flex-start !important;
  flex-wrap: wrap !important;
  padding: 10px !important;
  li {
    margin: 8px !important;
  }
}

.show-btn {
  &-sm {
    display: block;
    @media (min-width: @sizes[medium]) {
      display: none;
    }
  }
  &-md {
    cursor: pointer;
    display: none;
    @media (min-width: @sizes[medium]) {
      display: block;
    }
  }
}

.hide-btn {
  cursor: pointer;
  @media (max-width: @sizes[medium]) {
    display: none;
  }
}

.d-none {
  display: none;
}

.similar-card-bonus {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

figure > img {
  height: 100%;
  width: 100%;
}

.mw-260 {
  min-width: 260px;
  @media (min-width: @sizes[large]) {
    min-width: auto;
  }
}

// .mobile-scroller .row [class^="col-"] {
//   margin-right: 0px !important;
//   @media (max-width: @sizes[small]) {
//     margin-right: 8px !important;
//   }
// }

.term-re {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.terms-condition-similar {
  background: #dfe1e3;
  display: block;
  padding: 7px 8px;
  margin: 0;
  width: 100%;
  font-weight: 400;
  color: @lightdark;
  //min-height: 33px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  line-height: 15px;
  font-size: 0.75rem;
  white-space: pre-wrap;
  min-width: 254px;
  text-align: left;
  span {
    margin: auto 0;
  }
  @media (min-width: @sizes[medium]) {
    line-height: 18px;
    font-size: 0.75rem;
    text-align: left;
  }
  a {
    cursor: pointer;
    font-size: 12px;
    text-decoration: underline !important;
    &:hover {
      color: var(--primary-btn);
    }
  }
}

.casino-card-lists {
  margin-top: 10px !important;
  h6 {
    margin: 0 !important;
  }
}

.ltc-row {
  width: fit-content !important;
  @media (min-width: @sizes[medium]) {
    width: auto !important;
  }
  &:before {
    @media (max-width: @sizes[small]) {
      padding-left: 22px;
    }
  }
}

.pd-rt {
  h2,
  p {
    @media (max-width: @sizes[small]) {
      padding-left: 22px;
      padding-right: 22px;
    }
  }
}

.emt-sp {
  display: none;
  @media (min-width: @sizes[large]) {
    display: block;
    margin-bottom: 34px;
  }
}

.sim-logo {
  img {
    min-width: 50px;
  }
  @media (max-width: @sizes[medium]) {
    display: contents;
  }
}

.sm-img {
  margin: 0 !important;
}

.pay-space {
  display: block;
  margin-top: 10px !important;
  min-height: 69px;
}

.cas-nam {
  @media (min-width: @sizes[large]) {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
}

.stripe-sim {
  display: block;
  text-align: center;
  span {
    font-size: 12px;
    font-weight: 700;
    line-height: 160%;
    color: @white;
    display: flex !important;
    justify-content: center;
    align-items: center;
    top: 0;
    position: relative;
    height: 28px;
    svg,
    img {
      position: relative;
      width: 18px !important;
      min-width: 18px !important;
      top: 0;
      height: 18px !important;
      border-radius: 0px !important;
      object-fit: contain !important;
      margin: 0;
      margin-right: 5px;
    }
  }
}

.stripe-sim {
  position: absolute;
  width: 100%;
  height: 28px;
  overflow: hidden;
  top: 50%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: @yellow;
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
  @media (min-width: @sizes[large]) {
    display: block;
    top: 0;
    left: 0;
    border-radius: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  @media (max-width: @sizes[large]) {
    width: 90px;
    height: 20px;
    margin: 0 auto;
    //margin-left: 15px;
  }

  @media (max-width: @sizes[small]) {
    transform: translateY(26px);
  }
  // img {
  //   width: 18px;
  //   height: auto;
  //   margin: 3px auto;
  //   display: table;
  // }
}

.sim-best-ch {
  p {
    color: @black;
  }
}

.desk-sim {
  display: none !important;
  @media (min-width: @sizes[large]) {
    display: flex !important;
  }
}

.mob-sim {
  display: block;
  margin: 4px auto !important;
  width: 14px !important;
  min-width: 14px !important;
  //top: 2px;
  height: 14px !important;
  object-fit: contain !important;
  @media (min-width: @sizes[large]) {
    display: none;
  }
}

//New Design
.new-casino-card-section {
  padding-bottom: 25px;
}

.new-casino-card-row {
  .display-flex();
  .align-items(stretch);
  .justify-content-space-between();
  margin: 0 -6px;
}
.mobile-scroller {
  .row {
    &.row-stretch {
      .align-items(stretch);
    }
  }
}
.new-casino-card {
  .border-radius(10px);
  overflow: hidden;
  position: relative;
  max-width: 100%;
  // height: 505px;
  // margin: 0 6px;
  min-width: 280px;
  margin: 0 auto 16px;
  @media (min-width: @sizes[small]) {
    margin: 0;
  }
  @media (min-width: @sizes[tablet]) {
    min-width: auto;
  }
  .bg-holder {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .border-radius(10px 10px 0 0);
    overflow: hidden;
    z-index: -1;
    &:after {
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      .border-radius(10px 10px 0 0);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-content {
    position: relative;
    z-index: 1;
    padding: 32px 16px 16px;
    text-align: center;
    .cas-panel {
      margin-bottom: 35px;
      .cas-logo {
        width: 50px;
        height: 50px;
        margin-bottom: 8px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
          .border-radius(5px);
        }
      }
      .cas-title {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: @white;
        margin-bottom: 10px;
        display: block;
      }
      .rating-wrapper {
        line-height: 1;
        .rating-star-total {
          font-family: Helvetica;
          font-weight: normal;
          font-size: 16px;
          color: @white;
          span {
            font-weight: bold;
            font-size: 16px;
          }
        }
      }
    }
    .bonus-text {
      font-family: Helvetica;
      font-weight: bold;
      color: @white;
      font-size: 22px;
      line-height: 25px;
      margin-bottom: 34px;
      white-space: normal;
      a {
        color: @white;
        &:hover {
          color: var(--primary-btn) !important;
        }
      }
    }
    .review-link {
      display: inline-block;
      font-family: Helvetica;
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      color: @white;
      text-align: center;
      text-decoration: underline;
      margin-bottom: 32px;
      &:hover {
        text-decoration: underline;
      }
    }
    .cta-primary {
      display: block;
      background: #fe4646;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      .border-radius(5px);
      font-family: Helvetica;
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      max-width: 100%;
      border: 0;
      padding: 17px 20px;
      margin: 0;
    }
    .payment-options {
      margin-top: 16px;
      .display-flex();
      .align-items(center);
      .justify-content-center();
      li {
        margin: 0 4px;
        figure {
          .display-flex();
          .align-items(center);
          .justify-content-center();
          background: @white;
          .border-radius(5px);
          //padding: 6px 3.75px;
          width: 30px;
          height: 30px;
          font-family: Helvetica;
          font-weight: bold;
          font-size: 12px;
          line-height: 14px;
          color: #bdbdbe;
          img {
            height: 100%;
            width: 100%;
            .border-radius(5px);
            object-fit: contain;
          }
          .more-pay {
            display: flex;
            justify-content: center;
            align-items: center;
            color: inherit;
            &:hover {
              color: #222222;
              i {
                filter: brightness(2) invert(1) sepia(0.01);
              }
            }
            i {
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 7px;
                height: 7px;
              }
            }
          }
        }
      }
    }
  }
  .terms {
    background: #dfe1e3;
    .border-radius(0px 0px 10px 10px);
    padding: 7px 8px;
    text-align: center;
    p {
      font-family: Helvetica;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #222222;
      margin: 0;
    }
  }
  &.no-bg {
    filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05));
    .new-casino-card-content {
      background: @white;
      padding: 16px;
      .cas-panel {
        margin-bottom: 22px;
        .cas-logo {
          width: 90px;
          height: 90px;
        }
        .cas-title {
          color: #222222;
          margin-bottom: 8px;
        }
        .rating-wrapper {
          .rating-star-total {
            color: #222222;
          }
        }
      }
      ul {
        &.feature-lists {
          margin-bottom: 22px;
          padding-left: 21px;
          li {
            font-family: Helvetica;
            font-weight: normal;
            font-size: 12px;
            line-height: 14px;
            color: #222222;
            margin-bottom: 12px;
            position: relative;
            padding-left: 20px;
            text-align: left;
            &:last-child {
              margin-bottom: 0;
            }
            &:after {
              position: absolute;
              content: "";
              left: 0;
              top: 0;
              width: 0;
              height: 0;
              border-bottom: 11px solid #5abc5e;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
            }
          }
        }
      }
      .review-link {
        font-size: 12px;
        line-height: 14px;
        color: #9b9b9b;
        margin-bottom: 16px;
      }
    }
  }
}
.triangle {
  position: absolute;
  top: 2px;
  left: 2px;
  background-color: #0084ff;
  text-align: left;
  i {
    position: absolute;
    z-index: 1;
    transform: rotate(90deg);
    left: 5px;
    top: 5px;
    img {
      width: 18px;
      height: 18px;
    }
  }
  &.blue {
    background-color: #0084ff;
  }
  &.yellow {
    background-color: #ffd03a;
    i {
      left: 2px;
    }
  }
}
.triangle:before,
.triangle:after {
  content: "";
  position: absolute;
  background-color: inherit;
}
.triangle,
.triangle:before,
.triangle:after {
  width: 32px;
  height: 32px;
  border-top-right-radius: 8px;
}
.triangle:before,
.triangle:after {
  border-top-right-radius: 15px;
}
.triangle {
  transform: rotate(-90deg);
}
.triangle:before {
  transform: rotate(-135deg) skewX(-45deg) scale(1.41, 0.707) translate(0, -50%);
}
.triangle:after {
  transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.41) translate(50%);
}
.new-game-card-row {
  .display-flex();
  .align-items(stretch);
  .justify-content-space-between();
  margin: 0 -6px;
}

.mobile-scroller {
  &.disable {
    overflow-x: hidden;
    @media (min-width: @sizes[small]) {
      overflow-x: hidden;
    }
    .row {
      .flex-wrap(wrap);
      margin: 0px -8px;
      @media (min-width: @sizes[extra-small]) {
        margin: 0px;
      }
      @media (min-width: @sizes[small]) {
        .flex-wrap(nowrap);
        margin: 0 -8px;
      }
    }
  }
}

.mobile-scroller::-webkit-scrollbar {
  height: 0px;
}

.mobile-scroller {
  &:hover {
    overflow-x: auto !important;
    @media (min-width: @sizes[large]) {
      overflow-x: hidden !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/SimilarCasino.vue